import { useHTTP, useHTTPQuery } from "@/lib/http";

export interface SubscriptionModel {
	readonly activeSubscription: ActiveSubscriptionModel | null;
	readonly autoRenewPaymentCardId: string | null;
	readonly autoRenewPlanId: string | null;
	readonly autoRenewPlanName: string | null;
	readonly autoRenewFailureCount: number;
	readonly autoRenewPlanPrice: number;
	readonly hasPreviousSubscription: boolean;
}

export interface ActiveSubscriptionModel {
	readonly subscriptionId: string;
	readonly created: Date;
	readonly expiryDate: Date;
	readonly amountPaid: number;
	readonly paymentCardId: string;
	readonly planId: string;
	readonly planName: string;
	readonly clientCredentialsAccess: boolean;
}

export const useSubscription = () => {
	const http = useHTTP("Required");

	return useHTTPQuery({
		queryKey: ["subscription"],
		queryFn: () => http<SubscriptionModel>({
			method: "GET",
			url: "/subscription"
		})
	});
};
